exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".flatpickr-day.disabled {\n  opacity: 0.5;\n  color: #dc3545;\n}\n", ""]);

